// src/services/appointmentDetailApi.js
// Servicio para el detalle/carrito de servicios por cita (APPOINTMENT_DETAIL)

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Obtiene los servicios (detalle) de una cita
 * GET /appointmentDetail.php?appointment_id=1 o /appointmentDetail.php/1
 * @param {number} appointmentId - ID de la cita
 * @returns {Promise<Object>}
 */
export const getAppointmentDetails = async (appointmentId) => {
  try {
    const response = await dotoniwoofApi.get(`/appointmentDetail.php?appointment_id=${appointmentId}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al obtener servicios de la cita' }
    };
  }
};

/**
 * Añade un servicio al carrito/detalle de la cita
 * POST /appointmentDetail.php
 * Body: { id_appointment, id_item, quantity?, unit_price? }
 * @param {Object} body - id_appointment, id_item, quantity (default 1), unit_price
 * @returns {Promise<Object>}
 */
export const addAppointmentDetail = async (body) => {
  try {
    const response = await dotoniwoofApi.post('/appointmentDetail.php', {
      id_appointment: body.id_appointment,
      id_item: body.id_item,
      quantity: body.quantity ?? 1,
      unit_price: body.unit_price ?? 0
    });
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al añadir servicio' }
    };
  }
};

/**
 * Actualiza una línea del detalle (cantidad/precio)
 * PUT /appointmentDetail.php/{id_appointment_detail}
 * @param {number} idAppointmentDetail - ID de la línea
 * @param {Object} body - quantity, unit_price
 * @returns {Promise<Object>}
 */
export const updateAppointmentDetail = async (idAppointmentDetail, body) => {
  try {
    const response = await dotoniwoofApi.put(`/appointmentDetail.php/${idAppointmentDetail}`, body);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar línea' }
    };
  }
};

/**
 * Elimina un servicio del carrito/detalle
 * DELETE /appointmentDetail.php/{id_appointment_detail}
 * @param {number} idAppointmentDetail - ID de la línea
 * @returns {Promise<Object>}
 */
export const deleteAppointmentDetail = async (idAppointmentDetail) => {
  try {
    const response = await dotoniwoofApi.delete(`/appointmentDetail.php/${idAppointmentDetail}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al quitar servicio' }
    };
  }
};
